import { Component, OnInit } from '@angular/core';
import { I18nService } from '@shared/services/i18n.service';

@Component({
  selector: 'internal-user-identity-verified',
  templateUrl: './internal-user-identity-verified.component.html',
  styleUrl: './internal-user-identity-verified.component.scss'
})
export class InternalUserIdentityVerifiedComponent implements OnInit {

    constructor(
        private readonly i18nService: I18nService) { }

    ngOnInit() {
        this.i18nService.turnOnLanguageSelection();
    }
}
